
import { Options, Vue, Watch } from "vue-property-decorator";
import tabbar from "./tabbar.vue";

@Options({
  name: "layout",
  components: {
    tabbar,
  },
})
export default class extends Vue {
  includeList: any[] = [];
  @Watch("$route", { immediate: true })
  private routerChange(route: any) {
    //人员信息管理缓存优化
    if (
      route.path === "/system/workbench" ||
      route.path === "/system/project"
    ) {
      this.includeList = [];
    }
    if (route.meta.cache && this.includeList.indexOf(route.name) === -1) {
      this.includeList.push(route.name);
    }
  }

  @Watch("$store.state.project.projectinfo.projectId", { immediate: true })
  private projecrtChange(id: any) {
    this.includeList = [];
  }
}
